/* eslint-disable react/jsx-no-useless-fragment */
import React, { forwardRef, useState } from 'react';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box } from '@mui/material';

import styles from './taskSection.style';

const TaskSection = forwardRef(
  (
    {
      title,
      action,
      icon,
      children,
      isSmall,
      id,
      canExpand = true,
      customStyles,
      isEmbedded,
      disabled,
      ...rest
    },
    ref
  ) => {
    const [isOpen, setOpen] = useState(true);

    const handleToggle = () => {
      setOpen(!isOpen);
    };

    return (
      <Box
        ref={ref}
        sx={{
          ...styles.wrapper(disabled),
          ...(isSmall && styles.smallWrapper),
          ...customStyles,
          ...(isEmbedded && styles.embeddedWrapper),
        }}
        {...rest}
      >
        {!!id && <Box id={id} />}
        {title && (
          <Box sx={styles.header}>
            <Box
              sx={{ ...styles.title, ...(isEmbedded && styles.embeddedTitle) }}
            >
              {icon}
              {title}
            </Box>
            <Box sx={styles.actionsWrapper}>
              {action}
              {canExpand && (
                <>
                  {isOpen ? (
                    <KeyboardArrowUpIcon
                      data-testid="KeyboardArrowUpIcon"
                      onClick={handleToggle}
                    />
                  ) : (
                    <KeyboardArrowDownIcon
                      data-testid="KeyboardArrowDownIcon"
                      onClick={handleToggle}
                    />
                  )}
                </>
              )}
            </Box>
          </Box>
        )}
        <Box
          sx={{
            display: isOpen ? 'block' : 'none',
            marginTop: isOpen && title ? '24px' : '0',
          }}
        >
          {children}
        </Box>
      </Box>
    );
  }
);

export default TaskSection;
